import type { TourConfig } from '@components/tours/types';
import { WALLBOARD_TOUR_IDS } from './constants';

export const wallboardOverviewTour: TourConfig = {
  id: 'wallboard-overview',
  name: 'Wallboard Overview',
  description: 'Learn how to use the wallboard to monitor machine production status',
  steps: [
    {
      tourId: WALLBOARD_TOUR_IDS.MACHINE_TILE,
      popover: {
        title: 'Machine Tile',
        description: 'Each tile shows real-time production data for a machine including status, part image, timelines, and progress.',
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.TILE_HEADER,
      popover: {
        title: 'Machine Status',
        description: 'The colored header shows machine status: <span style="display:inline-block;width:10px;height:10px;background:#34C759;border-radius:2px;margin:0 2px;vertical-align:middle;"></span> Active, <span style="display:inline-block;width:10px;height:10px;background:#FF9500;border-radius:2px;margin:0 2px;vertical-align:middle;"></span> Change, <span style="display:inline-block;width:10px;height:10px;background:#AF52DE;border-radius:2px;margin:0 2px;vertical-align:middle;"></span> Setup, or <span style="display:inline-block;width:10px;height:10px;background:#8E8E93;border-radius:2px;margin:0 2px;vertical-align:middle;"></span> Not Productive.',
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.PART_IMAGE,
      popover: {
        title: 'Part Drawing / NC File',
        description: 'Shows what\'s currently being manufactured. When a <b>part image</b> is available, it appears here. If no image is uploaded, a preview of the <b>NC file content</b> (G-code) is shown instead.',
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.PRODUCTIVITY_TIMELINE,
      popover: {
        title: 'Productivity Time',
        description: 'Shows running time with target indicators: <span style="display:inline-block;width:10px;height:10px;background:#8E8E93;border-radius:50%;margin:0 2px;vertical-align:middle;"></span> Scheduled, <span style="display:inline-block;width:10px;height:10px;background:#007AFF;border-radius:50%;margin:0 2px;vertical-align:middle;"></span> Paid, and <span style="display:inline-block;width:10px;height:10px;background:#5AC8FA;border-radius:50%;margin:0 2px;vertical-align:middle;"></span> Ideal times.',
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.BATCH_TIMELINE,
      popover: {
        title: 'Batch Progress',
        description: 'Displays total batch duration with a colored timeline showing status changes throughout the shift.',
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.PIECES_PROGRESS,
      popover: {
        title: 'Pieces Gauge',
        description: 'Shows completed pieces vs target quantity as a circular gauge.',
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.OEE_GAUGE,
      popover: {
        title: 'OEE Today',
        description: "Today's OEE percentage, color-coded by performance tier.",
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.SCHEDULE_GAUGE,
      popover: {
        title: 'Days Ahead / Behind',
        description: 'ERP schedule deviation — green means ahead of schedule, red means behind.',
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.LEVEL_SELECTOR,
      popover: {
        title: 'Time View',
        description: 'Switch between 24h history, Day view, or Now (live tiles) to see different time perspectives.',
      },
    },
    {
      tourId: WALLBOARD_TOUR_IDS.MACHINE_FILTER,
      popover: {
        title: 'Machine Filter',
        description: 'Filter machines by department or group. Click to select a specific machine group.',
      },
    },
  ],
};
